export const combineQueries = (query1, query2) => {
  if (query1 === query2) {
    return query1;
  }

  let newQuery1 = query1;
  let newQuery2 = query2;
  if (newQuery1.slice(0, 1) === '?') {
    newQuery1 = newQuery1.replace('?', '');
  }
  if (newQuery2.slice(0, 1) === '?') {
    newQuery2 = newQuery2.replace('?', '');
  }
  if (newQuery1.slice(0, 1) === '&') {
    newQuery1 = newQuery1.replace('&', '');
  }
  if (newQuery2.slice(0, 1) === '&') {
    newQuery2 = newQuery2.replace('&', '');
  }

  if (newQuery1.length > 0 && newQuery1.slice(newQuery1.length - 1, newQuery1.length) !== '&') {
    newQuery1 += '&';
  }

  return (newQuery1 + '' + newQuery2).replace(' ', '%20');
};
